import $ from 'jquery';

import {
	getDOMElements
} from '../common/utilities.js';

// Import utilities
const {
	isDefined,
	isEmpty
} = _uo.utility;

import ItemHeaderMenu     from '../item/action-menu.js';
import ItemHeaderIcon     from '../item/integration-icon.js';
import ItemHeaderTag      from '../item/integration-name.js';
import ItemHeaderAsync    from '../item/button-schedule.js';
import ItemHeaderSentence from '../item/sentence.js';

// Import "Filter" button
import { canActionHaveFilterButton } from '@builder/item/conditions/utilities';
import { shouldBeSortable } from '@builder/item/sortability/utilities';

class MetaboxItems {
	constructor( itemType, items, options = {} ){
		// Get the parent element for the items
		const $metabox = getDOMElements( 'metabox', {
			type: itemType
		}).get(0);

		// Create wrapper for the items
		const $items = document.createElement( 'div' );
		$items.classList.add( 'uap-items' );

		// Check if we should add a custom class to the wrapper
		if ( isDefined( options.wrapperClass ) ) {
			$items.classList.add( options.wrapperClass );
		}

		$metabox.appendChild( $items );

		// Otherwise, simply add the items
		items.forEach( ( item ) => {
			// Append item
			$items.append( this.createItem( item.id ) );
		} );	
	}

	createItem( itemId ){
		// Get item data
		let item = UncannyAutomator.recipe.items[ itemId ];

		// Create container
		let container = $( '<div/>', {
			'class':   'uap-item item',
			'data-id': itemId
		});

		// Add data for devs to add custom CSS
		container[0].setAttribute( 'data-integration', item.integrationCode );
		container[0].setAttribute( 'data-item', item.itemCode );

		// Add property to the element
		container[0].itemId = itemId;

		if ( item.isMissing ){
			container.addClass( 'item--missing' );
		}

		// Check if it's sortable
		if ( isDefined( item.isSortable ) && item.isSortable ) {
			container.get(0).classList.add( 'uap-item--sortable' );
		} 

		if ( ! isEmpty( item.meta.async_mode ) ){
			if ( item.meta.async_mode === 'delay' ) {
				container.get(0).classList.add( 'uap-item--delayed' );
			} else {
				container.get(0).classList.add( 'uap-item--scheduled' );
			}
		} else {
			container.get(0).classList.add( 'uap-item--instant' );
		}

		// Replace tokens in the CSS
		if ( ! isEmpty( item.inlineCss ) ){
			item.inlineCss = item.inlineCss.replace( /{{item_id}}/g, itemId );

			// Add inline inlineCss
			container.prepend( item.inlineCss );
		}

		// Create header
		let header = this.createInner( itemId );

		let notice = this.createNotice( item );

		container.append( header );
		container.append( notice );

		container.on( 'automator:item:open', (e, open) => {
			let asyncButtons = container.find('.item-async');
			$( asyncButtons[0] ).trigger( 'automator:asyncButton:maybeDisable', open );           
		})

		return container.get(0);
	}

	/**
	 * Creates item header
	 * 
	 * @since 0.5
	 *
	 * @param {string}    integrationCode - The integration code
	 * @param {string}    itemType - The item type: 'trigger', 'action' or 'closure'
	 * @param {string}    itemCode - The code of the item
	 * @param {int}       itemId - The ID of the item
	 */
	createInner( itemId ){
		// Get item data
		const item = UncannyAutomator.recipe.items[ itemId ];

		// If the item is missing, override the integrationCode
		const integrationCode = item.isMissing ? null : item.integrationCode;

		// Get content
		const content = {
			// The sentence of the trigger/action/closure
			$sentence: new ItemHeaderSentence( item.itemType, integrationCode, item.itemCode, itemId ),

			// Icon. The integration icon
			$icon: new ItemHeaderIcon( integrationCode ),

			// Integration name tag
			$integrationNameTag: new ItemHeaderTag( {
				integrationId: integrationCode,
				customIntegrationName: item.integrationName
			} ),

			// The action menu. The three dots on the upper right corner.
			$actionMenu: new ItemHeaderMenu( item.itemType, integrationCode, item.itemCode, itemId ),
			
			// Buttons. These are added next to the action menu
			buttons: []
		}

		if ( canActionHaveFilterButton( itemId ) ) {
			// Create button
			const $filterButton = document.createElement( 'div' );
			$filterButton.classList.add( 'uap-item-button' );
			$filterButton.innerHTML = `
				<ua-builder-conditions-add-button 
					size="extra-small" 
					action-id="${ itemId }"
				>
					<uo-icon id="code-merge"></uo-icon> ${ UncannyAutomator.i18n.conditions.filter }
				</ua-builder-conditions-add-button>
			`;

			// Add the button
			content.buttons.push( $filterButton );
		}

		// Create "Schedule" button
		const scheduleButton = new ItemHeaderAsync( item.itemType, integrationCode, item.itemCode, itemId );

		// Check if we have to add the button
		if ( scheduleButton.shouldAddButton() ) {
			// Add the button
			content.buttons.push( scheduleButton.$button );
		}

		// Create content
		const $template = document.createElement( 'div' );
		$template.classList.add( 'uap-item-inner' );

		// Add content
		$template.insertAdjacentHTML( 'beforeEnd', `
			<div class="uap-item-sidebar"></div>
			<div class="uap-item-top-header">
				<div class="uap-item-top-header-left"></div>
				<div class="uap-item-top-header-right"></div>
			</div>
			<div class="uap-item-main"></div>
			<div class="uap-item-inner-content"></div>
		` );

		// Maybe add the drag and drop handler
		// Check if this should be draggable
		if ( shouldBeSortable( { actionID: item.id } ) ) {
			// Create handler
			const $handler = document.createElement( 'div' );
			$handler.classList.add( 'uap-item-drag-handle' );

			// Add icon
			$handler.innerHTML = `<uo-icon id="bars-regular"></uo-icon>`;

			// Add it to the block
			$template.insertAdjacentElement( 'afterBegin', $handler );
		}

		// Icon. The integration icon
		$template.querySelector( '.uap-item-sidebar' )
			.appendChild( content.$icon );

		// Add integration name tag
		$template.querySelector( '.uap-item-top-header-left' )
			.appendChild( content.$integrationNameTag );

		// Add action menu
		$template.querySelector( '.uap-item-top-header-right' )
			.appendChild( content.$actionMenu.get(0) );

		// The sentence of the trigger/action/closure
		$template.querySelector( '.uap-item-main' )
			.appendChild( content.$sentence.get(0) );

		// Add buttons
		content.buttons.forEach( ( $button ) => {
			// Append the button
			$template.querySelector( '.uap-item-top-header-right' )
				.appendChild( $button );
		} );

		// Check if we have to add the item ID
		if ( isDefined( item.shouldShowItemId ) && item.shouldShowItemId ) {
			// Add item ID
			$template.querySelector( '.uap-item-top-header-left' )
				.appendChild( this.$createItemID( itemId ) );
		}

		return $template;
	}

	/**
	 * Create item notice
	 *
	 * @since 0.6
	 *
	 */

	createNotice( item ){
		let container;

		if ( item.isMissing ){
			container = $( '<uo-alert/>', {
				type: 'warning'
			});
			
			container.text( UncannyAutomator.i18n.itemMissing );
		}

		return container;
	}

	/**
	 * Returns an element that contains the item ID
	 * 
	 * @return {Node} The element with the item ID
	 */
	$createItemID( itemId = '' ) {
		// Create the wrapper
		const $wrapper = document.createElement( 'div' );
		$wrapper.classList.add( 'uap-item-id' );

		// Add the ID
		$wrapper.innerText = sprintf( '#%1$s', itemId );

		return $wrapper;
	}
}

export default MetaboxItems;